// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__FS7Gc","description":"style_description__nQHJ3","propertyName":"style_propertyName__Xs9St","btnContainer":"style_btnContainer__3_lMc"};